import { render } from "./SkilupEventComponent.vue?vue&type=template&id=51dbe9ce&scoped=true&ts=true"
import script from "./SkilupEventComponent.vue?vue&type=script&lang=ts"
export * from "./SkilupEventComponent.vue?vue&type=script&lang=ts"

import "./SkilupEventComponent.vue?vue&type=style&index=0&id=51dbe9ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dbe9ce"]])

export default __exports__